/** localStorage keys for auth session fields. */
export const ACCESS_TOKEN_KEY = "access_token";
export const REFRESH_TOKEN_KEY = "refresh_token";

/** Login / refresh payload from the API (camelCase or snake_case). */
export type LoginLikeTokens = {
  accessToken?: string;
  access_token?: string;
  refreshToken?: string;
  refresh_token?: string;
};

const pickAccessToken = (data: LoginLikeTokens) =>
  data.accessToken ?? data.access_token ?? "";

const pickRefreshToken = (data: LoginLikeTokens) =>
  data.refreshToken ?? data.refresh_token ?? "";

export const setTokens = (data: LoginLikeTokens) => {
  const accessToken = pickAccessToken(data);
  const refreshToken = pickRefreshToken(data);

  if (accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const removeTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
